import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=476c3a25"
import script from "./KnowledgeBase.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports